import classnames from "classnames";
import React from "react";
import style from "./style.module.scss";

type PropTypes = {
    children?: string | JSX.Element | JSX.Element[];
    hasTopBar?: boolean;
    isCollapsed?: boolean;
    isOpen?: boolean;
    ref?: MutableRefObject<HTMLDivElement>;
};

export const TableOfContentsWrapper = (props: PropTypes): JSX.Element => {
    const { children, hasTopBar, isCollapsed, isOpen, ref } = props;

    return (
        <div
            ref={ref}
            className={classnames(
                style.tocWrapper,
                hasTopBar ? style.hasTopBar : null,
                isCollapsed ? null : style.bigHeader,
                isOpen ? style.open : null,
            )}
            data-test-id="toc-wrapper"
            id="toc-wrapper-id"
        >
            {children}
        </div>
    );
};

export default TableOfContentsWrapper;
